import { getApi , postApi , putApi , deleteApi } from "../api";

export const getAllAdminCardApi = () => getApi(`/user/getAdminCard`);
export const getThisWeekBusinessAdminApi = () => getApi(`/user/this-week-business`);
export const getThisWeekPaymentsAdminApi = () => getApi(`/user/this-week-payments`);
